<div class="custom-bg-container rounded-lg shadow m-5 text-md dark:bg-gray-800">

    <div class="p-4 bg-white dark:bg-gray-800 rounded-t-lg">
        <div class="flex items-center mb-4">
            <div class="flex items-center justify-center h-8">
                <img class="w-6 h-6" src="img/stamp-approve-icon.png" alt="Stamp Approve Icon">
            </div>
            <h1 class="text-2xl font-bold ml-3 my-theme-color-text">Approve Stamp Requests</h1>
        </div>
        <div class="relative mb-4">
            <input type="text" placeholder="Search by Request ID or Citizen Name" class="border border-gray-300 dark:border-gray-600 rounded-lg p-2 w-full pl-10 
                            focus:outline-none 
                            focus:ring-2 
                            my-theme-color-input bg-white dark:bg-gray-700 dark:text-gray-200"
                [(ngModel)]="searchQuery" (input)="filterRequests()">
            <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z" />
                </svg>
            </span>
        </div>
    </div>
    <div class="flex flex-col overflow-x-auto p-4  bg-white dark:bg-gray-800 rounded-b-lg">
        <table class="min-w-full bg-white dark:bg-gray-800 shadow-md">
            <thead>
                <tr class="bg-gray-200 dark:bg-gray-700">
                    <th
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider custom-border-table-left">
                        Request ID</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Citizen Name</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Stamp Type</th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status</th>
                    <th class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let request of paginatedRequests"
                    class="hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700">
                    <td class="px-6 py-4 whitespace-nowrap text-gray-500 dark:text-gray-300">{{ request.id }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-gray-500 dark:text-gray-300">{{ request.citizenName
                        }}</td>
                    <td class="px-6 py-4 whitespace-nowrap text-gray-500 dark:text-gray-300">{{ request.stampType }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-gray-500 dark:text-gray-300">{{ request.status }}
                    </td>
                    <td class="px-2 py-4 whitespace-nowrap text-gray-500 dark:text-gray-300 text-center">
                        <button (click)="modalSelectRequest = true" class=" text-white bg-green-400 rounded-lg p-2
                                            hover:bg-green-500 hover:text-white hover:border-green-400
                                        ">
                            Approve
                        </button>
                        <button (click)="modalSelectReject = true" class="text-white ml-2 bg-red-500 rounded-lg p-2
                                           hover:bg-red-600 hover:text-white hover:border-red-500
                                        ">
                            Reject

                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <!----------------------------- ปุ่ม Previous < > Next ------------------------------------>
        <div class="flex justify-between items-center mt-4 px-4">
            <button (click)="prevPage()" [disabled]="currentPage === 1"
                class="bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 px-4 py-2 rounded disabled:opacity-50">
                Previous
            </button>

            <span class="text-gray-600 dark:text-gray-300">
                Page {{ currentPage }} of {{ totalPages }}
            </span>

            <button (click)="nextPage()" [disabled]="currentPage === totalPages"
                class="bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-200 px-4 py-2 rounded disabled:opacity-50">
                Next
            </button>
        </div>
    </div>
</div>
<!--------------------------------- หน้าต่าง Popup Approve --------------------------------->
<div class="fixed flex inset-0 bg-black/50 overflow-y-auto z-50 justify-center items-center" *ngIf="modalSelectRequest">
    <div
        class="custom-detail custom-detail-small bg-white dark:bg-gray-800 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh] max-w-4xl w-full mx-4">
        <div class="flex justify-between pt-6 pl-6 pr-6 shadow-md border-b dark:border-gray-700 pb-4">
            <h2 class="text-xl font-semibold mb-4 mb-4 my-theme-text dark:text-yellow-500">รายละเอียดการจอดรถ</h2>
            <!-- ปุ่มปิด -->
            <button (click)="modalSelectRequest = false"
                class="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-4xl font-bold">
                &times;
            </button>
        </div>
        <div class="p-5">
            <!-- 1 row: ส่วนลดค่าบริการ + ผู้ให้ส่วนลด -->
            <div class="flex flex-wrap gap-4 mb-4 ">
                <!-- ส่วนลดค่าบริการ -->
                <div class="w-full sm:flex-1">
                    <div class=" flex items-center space-x-1">
                        <span class="text-red-600">*</span>
                        <span class="block text-sm font-medium mb-1 dark:text-gray-300">ส่วนลดค่าบริการ</span>
                    </div>
                    <div class="relative">
                        <button (click)="isOpen = !isOpen"
                            class="border bg-white dark:bg-gray-700 dark:text-gray-200 border-gray-300 dark:border-gray-600 px-4 py-2 w-full text-left rounded-md font-small flex justify-between items-center z-10">

                            <span>{{ selectedStamp ? selectedStamp.name : 'เลือกส่วนลดค่าบริการ' }}</span>

                            <span class="transition-transform duration-300"
                                [style.transform]="isOpen ? 'rotate(180deg)' : 'rotate(0deg)'">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                </svg>
                            </span>
                        </button>

                        <ul *ngIf="isOpen"
                            class="absolute z-20 bg-white dark:bg-gray-700 border dark:border-gray-600 w-full mt-1 max-h-60 overflow-y-auto rounded shadow text-gray-700 dark:text-gray-200">
                            <li class="px-4 py-2 my-theme-color-hover cursor-pointer" (click)="selectStampOption(null)">
                                ไม่มี</li>
                            <li *ngFor="let opt of ParkingData!.stamplist" (click)="selectStampOption(opt)"
                                class="px-4 py-2 my-theme-color-hover cursor-pointer" [ngClass]="{
                                        'bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300': opt.name === 'discount',
                                        'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300': opt.name === 'none'
                                    }">
                                {{ opt.name || 'ไม่มี' }}
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- ผู้ให้ส่วนลด -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">ผู้ให้ส่วนลด</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ userName == '' ?
                        'ไม่มีข้อมูล' : userName }}</p>
                </div>
            </div>

            <!-- 2 row: เลขบัตรจอดรถ + ทะเบียนรถ -->
            <div class="flex flex-wrap gap-4 mb-4">
                <!-- เลขบัตรจอดรถ -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">เลขบัตรจอดรถ</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ ParkingData ?
                        ParkingData.cardcode : 'ไม่มีข้อมูล' }}
                    </p>
                </div>
                <!-- ทะเบียนรถ -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">ทะเบียนรถ</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ ParkingData ?
                        ParkingData.license : 'ไม่มีข้อมูล' }}
                    </p>
                </div>
            </div>

            <!-- 3 row: วันเวลาเข้า + วันเวลาออก -->
            <div class="flex flex-wrap gap-4 mb-4">
                <!-- วันเวลาเข้า -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">วันเวลาเข้า</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{
                        ParkingData
                        ? (ParkingData.entry_date | date : "dd/MM/yyyy HH:mm")
                        : 'ไม่มีข้อมูล'
                        }}
                    </p>
                </div>
                <!-- วันเวลาออก -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">วันเวลาออก</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{
                        ParkingData
                        ? (ParkingData.exit_date | date : "dd/MM/yyyy HH:mm")
                        : 'ไม่มีข้อมูล' }}
                    </p>
                </div>
            </div>

            <!-- 4 row: ประเภทรถ + ประตูเข้า -->
            <div class="flex flex-wrap gap-4 mb-4">
                <!-- ประเภทรถ -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">ประเภทรถ</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ ParkingData ?
                        ParkingData.vehicletypename :
                        'ไม่มีข้อมูล' }}</p>
                </div>
                <!-- ประตูเข้า -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">ประตูเข้า</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ ParkingData ?
                        ParkingData.entrygate : 'ไม่มีข้อมูล'}}
                    </p>
                </div>
            </div>

            <!-- 5 row: ระยะเวลาจอด + อัตราค่าบริการจอดรถ -->
            <div class="flex flex-wrap gap-4 mb-4">
                <!-- ระยะเวลาจอด -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">ระยะเวลาจอด</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ ParkingData ?
                        ParkingData.parkingtime : 'ไม่มีข้อมูล'}}
                    </p>
                </div>
                <!-- อัตราค่าบริการจอดรถ -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">อัตราค่าบริการจอดรถ</label>
                    <p class="bg-gray-100 dark:bg-gray-700 dark:text-gray-200 p-2 rounded-md">{{ ParkingData ?
                        ParkingData.stamp : 'ไม่มีข้อมูล' }}</p>
                </div>
            </div>

            <!-- 5.1 row: รูปภาพหลักฐาน (ถ้ามี) -->
            <div class="mb-4">
                <label class="block text-sm font-medium mb-1 dark:text-gray-300">รูปภาพหลักฐาน</label>
                <div *ngIf="demoImage; else noImage">
                    <img [src]="demoImage" alt="หลักฐาน"
                        class="w-32 h-32 object-cover rounded cursor-pointer border dark:border-gray-600"
                        (click)="selectImageExpanded()">
                </div>
                <ng-template #noImage>
                    <p class="text-gray-400">ไม่มีรูปภาพ</p>
                </ng-template>
            </div>

            <!-- Popup แสดงรูปภาพขยาย -->
            <div *ngIf="expandedImage"
                class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
                <div class="relative">
                    <img [src]="expandedImage" alt="หลักฐานขยาย"
                        class="max-w-[90vw] max-h-[80vh] rounded shadow-lg border-4 border-white">
                    <button (click)="expandedImage = null"
                        class="absolute top-2 right-2 bg-white rounded-full p-2 shadow hover:bg-red-500 hover:text-white transition"
                        aria-label="ปิด">
                        &times;
                    </button>
                </div>
            </div>

            <!-- 6 row: หมายเหตุ  -->
            <div>
                <!-- หมายเหตุ -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">หมายเหตุ</label>
                    <textarea type="text" class="w-full border dark:border-gray-600 px-3 py-2 rounded bg-white dark:bg-gray-700 dark:text-gray-200
                            focus:outline-none focus:ring-2 my-theme-color-input" placeholder="กรอกหมายเหตุ"
                        [ngModel]="ParkingData ? ParkingData.message : 'ไม่มีข้อมูล'">
                        </textarea>
                </div>
            </div>

            <!-- 7 row: ค่าบริการที่ต้องชำระ  -->
            <div>
                <!-- ค่าบริการที่ต้องชำระ -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">
                        ค่าบริการที่ต้องชำระ : <label class="my-theme-text soft dark:text-yellow-500">{{
                            discountAmountDemo != null ?
                            discountAmountDemo : ParkingData ? ParkingData.amounttopay : 0 }}</label> บาท
                    </label>
                </div>
            </div>

            <!-- 8 row: ค่าบริการชำระเงินแล้ว  -->
            <div>
                <!-- ค่าบริการชำระเงิน -->
                <div class="w-full sm:flex-1">
                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">
                        ค่าบริการชำระแล้ว : <label class="text-gray-500 dark:text-gray-400">{{ ParkingData ?
                            ParkingData.paid : 0
                            }}</label> บาท
                    </label>
                </div>
            </div>

        </div>
        <!-- ปุ่มกด ยืนยัน-ยกเลิก -->
        <div class="flex justify-center mt-5">
            <button class="text-white px-5 pb-4 pt-2 my-theme-color-btn-next my-custom-box-next w-full"
                (click)="checkApproveRequest( ParkingData ? ParkingData.cardcode : '')">
                แสตมป์
            </button>
            <button class="text-white px-5 pb-4 pt-2 my-custom-box-cancel w-full"
                (click)="modalSelectRequest = false">ยกเลิก</button>

        </div>
    </div>
</div>

<!--------------------------------- หน้าต่าง Popup Reject --------------------------------->
<div class="fixed flex inset-0 bg-black/50 overflow-y-auto z-50 justify-center items-center" *ngIf="modalSelectReject">
    <div
        class="custom-detail custom-detail-small bg-white dark:bg-gray-800 rounded-lg shadow-lg relative overflow-y-auto max-h-[90vh] max-w-4xl w-full mx-4">
        <div>
            <div class="p-4">
                <h1 class="text-2xl dark:text-gray-200">คุณต้องการ <label
                        class="my-theme-color-text dark:text-yellow-500">ยืนยัน</label>
                    การปฎิเสธการร้องขอนี้ไหม?</h1>
                <textarea class="w-full border dark:border-gray-600 px-3 py-2 rounded mt-4 bg-white dark:bg-gray-700 dark:text-gray-200
                        focus:outline-none focus:ring-2 my-theme-color-input" placeholder="กรอกหมายเหตุ"
                    [(ngModel)]="rejectReason">

                    </textarea>
            </div>
            <!-- ปุ่มกด ยืนยัน-ยกเลิก -->
            <div class="flex justify-center mt-5">
                <button class="text-white px-5 pb-4 pt-2 my-theme-color-btn-next my-custom-box-next w-full"
                    (click)="checkRejectRequest( ParkingData ? ParkingData.cardcode : '')">
                    ยืนยัน
                </button>
                <button class="text-white px-5 pb-4 pt-2 my-custom-box-cancel w-full"
                    (click)="modalSelectReject = false">ยกเลิก</button>
            </div>
        </div>
    </div>


</div>